// extracted by mini-css-extract-plugin
module.exports = {"refLink":"e_pp","refLinkDesktop":"e_qp","titleFont":"e_rp"};